import React from 'react';

import classes from './StickyToTopButton.css';

import UpIcon from '../../../../icons/pageTop.svg';

const stickyToTopButton = props => {
    return (
        <div className={classes.StickyButton} >
                    <div className={classes.StickyButtonHelper}
                        onClick={props.clicked}>
                        <img 
                            src={UpIcon}
                            alt="not found" />
                    </div>
                </div>
    )
}

export default stickyToTopButton;


// WEBPACK FOOTER //
// ./src/components/UI/Buttons/StickyToTopButton/StickyToTopButton.js